export default function formatPatientAge(age: string | null | undefined) {
  return age?.startsWith('0') ? `(${age.substring(1)})` : age || '';
}
